import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { 
  REQUEST, 
  createSegmentSuccess, 
  createSegmentFailure 
} from '../../actions/segments/create';
import { fetchRequest as fetchSegments } from '../../actions/segments/list';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import { Error as ErrorAction } from '../../actions/error/error';

// Worker saga for creating a segment
function* createSegment(action) {
  try {
    // Get headers from the utility function
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    // Add content type header
    headers['Content-Type'] = 'application/json';
    
    const response = yield call(axios.post, 
      `${config.API_URL}/segment`,
      action.payload,
      { headers }
    );

    // Dispatch success action with the response data
    yield put(createSegmentSuccess(response.data));
    
    // Add success snackbar message
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Segment created successfully' });
    
    // Refresh the segments list after successful creation
    yield put(fetchSegments({}));
    
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    const errorMessage = extractErrorMessage(error);
    console.error('Create segment saga error:', errorMessage, error?.response?.status);

    yield put(ErrorAction(error));
    yield put(createSegmentFailure(errorMessage));

    return {
      success: false,
      error: errorMessage
    };
  }
}

// Watcher saga for segment creation
export function* watch() {
  yield takeLatest(REQUEST, createSegment);
} 